




























import { Component, Vue } from "vue-property-decorator";

type ExpansionPanel = {
  header: string;
  arrayOfText: { text: string | string[]; asList?: boolean }[];
};

@Component
class PaymentHelpCard extends Vue {
  listItems(text: any) {
    return text
  }

  panel1 = {
    header: "Как осуществить платеж картой?",
    arrayOfText: [
      {
        asList: true,
        text: [
          "Проверьте параметры платежа.",
          "Если параметры платежа корректны, то отметьте флажок о подтверждении параметров платежа.",
          "Нажмите на кнопку «Перейти к оплате».",
          "На странице банка введите данные банковской карты и смс-код подтверждения операции.",
        ],
      },
    ],
  };

  panel3 = {
    header: "Безопасность платежей",
    arrayOfText: [
      {
        text: "Безопасность платежей обеспечивается с помощью Банка-эквайера, функционирующего на основе современных протоколов и технологий, разработанных международными платежными системами.",
      },
      {
        text: "Обработка полученных конфиденциальных данных Держателя карты производится в процессинговом центре Банка-эквайера по закрытым сетям передачи данных, сертифицированным международными платежными системами для доставки конфиденциальной финансовой информации.",
      },
      {
        text: "Безопасность передаваемой информации обеспечивается с помощью современных протоколов обеспечения безопасности в Интернет.",
      },
    ],
  };

  panels: ExpansionPanel[] = [this.panel1, this.panel3];
}

export default PaymentHelpCard;
